import { cn } from '@bem-react/classname';

export const cnStreamScreen = cn('StreamScreen');
